import * as FrontendUtils from 'utils';

const localStorageKeys = [
  'cloud_admin__selected_costcenter_seqgeq',
  'cloud_admin__selected_costcenter_flowjo',
];

export function localStorageCleanupOnSignOut(): void {
  for (const key of localStorageKeys) {
    FrontendUtils.removeClientStorageValue(key);
  }
}
